module.exports = __webpack_public_path__ + "static/media/mastercard.30764bef.jpg";